const styles = (theme) => ({
  root: {
    ...theme.mixins.modal.dialog.root,
  },
});
export default styles;
